import { ref, readonly, useContext } from "@nuxtjs/composition-api";
function useCompany() {
  const loading = ref(false);
  const error = ref({
    load: null
  });
  const company = ref(null);
  const { app } = useContext();
  const load = async () => {
    try {
      loading.value = true;
      const { data } = await app.$vsf.$magento.api.company();
      if (data == null ? void 0 : data.AmastyCompany) {
        company.value = data.AmastyCompany;
      }
    } catch (err) {
      error.value.load = err;
    } finally {
      loading.value = false;
    }
    return company.value;
  };
  const isExtendedCompany = app.$wm.company.extendedCompany;
  function getBillingAddress(company2) {
    var _a, _b, _c, _d, _e, _f;
    let address = null;
    if (isExtendedCompany && ((_a = company2.addresses) == null ? void 0 : _a.length) > 0) {
      address = (_c = (_b = company2.addresses) == null ? void 0 : _b.find((address2) => address2.default_billing)) != null ? _c : null;
    } else if (isExtendedCompany) {
      address = {
        city: company2.city,
        country_code: "NO",
        default_billing: true,
        company: company2.company_name,
        postcode: company2.postcode,
        street: [company2.street]
      };
    } else {
      address = (_f = (_e = (_d = company2.super_user) == null ? void 0 : _d.addresses) == null ? void 0 : _e.find((address2) => address2.default_billing)) != null ? _f : null;
    }
    return address;
  }
  function getShippingAddress(company2) {
    var _a, _b, _c, _d, _e, _f;
    let address = null;
    if (isExtendedCompany && ((_a = company2.addresses) == null ? void 0 : _a.length) > 0) {
      address = (_c = (_b = company2.addresses) == null ? void 0 : _b.find((address2) => address2.default_shipping)) != null ? _c : null;
    } else if (isExtendedCompany) {
      address = {
        city: company2.city,
        country_code: "NO",
        default_shipping: true,
        company: company2.company_name,
        postcode: company2.postcode,
        street: [company2.street]
      };
    } else {
      address = (_f = (_e = (_d = company2.super_user) == null ? void 0 : _d.addresses) == null ? void 0 : _e.find((address2) => address2.default_shipping)) != null ? _f : null;
    }
    return address;
  }
  return {
    loading: readonly(loading),
    error: readonly(error),
    company,
    isExtendedCompany,
    load,
    getBillingAddress,
    getShippingAddress
  };
}
export {
  useCompany
};
